<script setup lang="ts">
import PejerGraphProvider from 'pejer/src/components/Chart/PejerGraphProvider.vue'
import DataStateDisplay from 'pejer/src/components/DataState/DataStateDisplay.vue'
import SectionCard from 'pejer/src/components/ui/section-card/SectionCard.vue'
import SectionCardHeader from 'pejer/src/components/ui/section-card/SectionCardHeader.vue'
import { PejerTablesList } from 'pejer/src/types/base'
import { Filters } from 'pejer/src/types/types'
import { usePejerBase } from '../../stores/pejerData'
import AccountsPayoutsDonutChart from '../Chart/ConnectedAccounts/AccountsPayoutsDonutChart.vue'
import PejerCreatedGraph from '../Chart/General/PejerCreatedGraph.vue'
const pejer = usePejerBase()

defineProps<{
  query?: Filters<PejerTablesList<'connectedAccounts'>>
}>()
</script>
<template>
  <div class="grid grid-cols-5 gap-2">
    <PejerGraphProvider
      :query="query"
      v-slot="{ data, dataState }"
      :url="pejer.urls.connectedAccounts.stats"
      groupBy="month"
    >
      <div class="flex flex-col gap-2 h-full col-span-3">
        <SectionCard>
          <SectionCardHeader class="w-full"> Total Connected Accounts </SectionCardHeader>
          <DataStateDisplay :="dataState">
            {{ data?.reduce((acc, item) => acc + item.count, 0) }}
            </DataStateDisplay>
        </SectionCard>
        <SectionCard class="flex flex-col gap-2 col-span-3">
          <SectionCardHeader class="w-full"> Connected Accounts Created </SectionCardHeader>
          <div class="flex-grow h-0 flex-1">
            <PejerCreatedGraph :data="data" />
          </div>
        </SectionCard>
      </div>

      <SectionCard class="h-full flex items-center col-span-2">
        <AccountsPayoutsDonutChart :data="data" />
      </SectionCard>
    </PejerGraphProvider>
  </div>
</template>
